import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import {
  facebookURL,
  IconFacebook,
  IconInstagram,
  IconPinterest,
  IconTwitter,
  instagramURL,
  pinterestURL,
  twitterURL,
} from '@noths/polaris-client-ribbons-design-system';

import * as styles from './FooterSocialMedia.styles';

interface SocialMediaLinkProps {
  children: React.ReactNode;
  href: string;
  title: string;
}

const SocialMediaLink = ({ children, href, title }: SocialMediaLinkProps) => {
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();
  const trackingEvent = {
    event: 'custom_event',
    event_action: 'Social click',
    event_category: 'Footer',
    event_label: title,
  };

  return (
    <a
      href={href}
      target="_blank"
      title={title}
      rel="noreferrer"
      onClick={trackLinkClick(trackingEvent)}
      onMouseDown={trackLinkMouseDown(trackingEvent)}
      css={styles.link}
    >
      {children}
    </a>
  );
};

export const FooterSocialMedia = () => {
  return (
    <div css={styles.container}>
      <SocialMediaLink href={facebookURL} title="Facebook">
        <IconFacebook css={styles.icon} color={'var(--dgg-neutral-white)'} />
      </SocialMediaLink>
      <SocialMediaLink href={twitterURL} title="Twitter">
        <IconTwitter css={styles.icon} color={'var(--dgg-neutral-white)'} />
      </SocialMediaLink>
      <SocialMediaLink href={pinterestURL} title="Pinterest">
        <IconPinterest css={styles.icon} color={'var(--dgg-neutral-white)'} />
      </SocialMediaLink>
      <SocialMediaLink href={instagramURL} title="Instagram">
        <IconInstagram css={styles.icon} color={'var(--dgg-neutral-white)'} />
      </SocialMediaLink>
    </div>
  );
};
